import CampaignInstantLuckyDrawPanel from './campaignInstantLuckyDraw.container';

export default CampaignInstantLuckyDrawPanel;